var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"back",on:{"click":function($event){return _vm.$router.back()}}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" 返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }